import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Logo } from "@/components/site/Logo";
import { AuthProvider, RequireAuth, useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";

const AdminLayout = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-brand-mist">
      <header className="bg-brand-anthracite">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4">
            <Logo light testId="admin-logo" />
            <span className="hidden rounded-full bg-brand-yellow px-2.5 py-0.5 text-xs font-bold text-brand-anthracite sm:inline">Admin</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-white/80">
            <span className="hidden sm:inline" data-testid="admin-user-email">{user?.email}</span>
            <button type="button" onClick={logout} data-testid="admin-logout-button"
              className="inline-flex items-center gap-1.5 rounded-full border border-white/20 px-3.5 py-1.5 font-semibold text-white transition-colors hover:bg-white/10">
              <LogOut className="h-4 w-4" /> Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8"><Outlet /></main>
    </div>
  );
};

export default function AdminApp() {
  return (
    <AuthProvider>
      <Seo title="Admin – Anfragen | Marcone" description="Admin-Bereich" path="/admin" noindex />
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<RequireAuth />}>
          <Route element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="anfragen/:id" element={<AdminLeadDetail />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}
